import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import SSIIconButton from '../../buttons/SSIIconButton';
import { ButtonIconsEnum } from '../../../types';
import { SSIDropDownListContainerStyled as Container, SSITextH3Styled as LabelCaption, SSIDropDownListSelectedValueStyled as SelectedValue, } from '../../../styles/components';
const SSIDropDownList = (props) => {
    const { initialValue, label } = props;
    const [value, setValue] = React.useState(initialValue);
    return (_jsxs(Container, { children: [label && _jsx(LabelCaption, { children: label }), _jsx(SelectedValue, { children: value }), _jsx(SSIIconButton, { icon: ButtonIconsEnum.ARROW_DOWN, onClick: async () => console.log('drop down clicked') })] }));
};
export default SSIDropDownList;
